import { FocusEvent, memo, useCallback } from 'react';
import Highlighter from 'react-highlight-words';

import { highlightStyle } from '@/components/atom/QuestionsListItems/QuestionsListItems.styles';

import { TQuestionListItemProps } from './types';

const ONBOARDING_CLASSES = 'list-group-item-primary bg-highlight-lightest';
const ONBOARDING_QUESTION_TEST_ID = 'onboarding-demo-question';

const QuestionListItem = ({
  faq,
  isOnboardingQuestion,
  searchWords,
  tabIndex,
  itemRef,
  onSelect,
}: TQuestionListItemProps) => {
  const handleClick = useCallback(() => onSelect(faq), [onSelect, faq]);

  const handleFocus = useCallback((event: FocusEvent<HTMLButtonElement>) => {
    // INFO: The list scrolls, so an item reached by arrow key has to be pulled into view itself —
    // roving tabindex moves focus without the browser scrolling for it in every engine.
    event.currentTarget.scrollIntoView({ block: 'nearest' });
  }, []);

  return (
    <button
      type="button"
      tabIndex={tabIndex}
      ref={itemRef}
      className={`list-group-item list-group-item-link ${isOnboardingQuestion ? ONBOARDING_CLASSES : ''}`}
      data-testid={isOnboardingQuestion ? ONBOARDING_QUESTION_TEST_ID : undefined}
      onClick={handleClick}
      onFocus={handleFocus}
    >
      <Highlighter highlightStyle={highlightStyle} searchWords={searchWords} autoEscape textToHighlight={faq.name} />
    </button>
  );
};

export default memo(QuestionListItem);
